import React from 'react';
import PropTypes from 'prop-types';
import NavLink from './NavLink';

/**
 * DrilldownLeafLink — renders a single ungrouped leaf link inside a list item.
 *
 * @param {Object} props
 * @param {NavigationItem} props.item - A navigation item with a real URL
 * @param {() => void} props.onLinkClick - Called when the link is clicked
 */
const DrilldownLeafLink = ({ item, onLinkClick }) => (
	<li>
		<NavLink item={item} onLinkClick={onLinkClick} />
	</li>
);

DrilldownLeafLink.propTypes = {
	item: PropTypes.shape({
		label: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired
	}).isRequired,
	onLinkClick: PropTypes.func.isRequired
};

export default DrilldownLeafLink;
